import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { colors } from '../../utils/colors';

export const ContainerHeader = styled.div`
  border-top: 5px solid ${colors.verde};
  border-bottom: 1px solid ${colors.cinza10};
  z-index: 0;
  position: relative;
  background-color: white;
`;

export const ConteudoContainer = styled.div`
  max-width: 1400px;
  width: 100%;
  margin: 15px auto 0 auto;
  position: relative;
  display: flex;
  flex-direction: row;
`;

export const Linkcomponent = styled(NavLink)`
  color: ${colors.cinza};
  text-decoration: none;
  font-weight: 500;
  margin-left: 20px;

  &:hover {
    color: ${colors.verde};
  }
`;

export const ColumContainer = styled.div<{ primary?: boolean; logo?: boolean }>`
  width: ${(props) => (props.logo ? '200px' : 'calc(100% - 200px)')};
  box-sizing: border-box;
  padding-left: 10px;

  ${(props) =>
    props.primary &&
    css`
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: flex-end;
      padding-right: 10px;

      @media (max-width: 768px) {
        justify-content: flex-end;
      }
    `};

  ${(props) =>
    props.logo &&
    css`
      img {
        width: 100%;
        @media (max-width: 768px) {
          width: 120px;
        }
        @media (max-width: 435px) {
          margin-top: 40px;
        }
      }
    `};
`;

export const OtherItems = styled.div`
  position: absolute;
  top: 0;
  display: flex;
  z-index: 2;
`;

export const MenuItems = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileMenu = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;

export const SocialMidia = styled.div`
  color: ${colors.branco};
  width: 27px;
  height: 27px;
  background-color: ${colors.cinza};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-left: 10px;

  &:hover {
    background-color: ${colors.verde};
  }
`;

export const BoxContato = styled.div`
  width: 226px;
  height: 47px;
  background-color: ${colors.branco};
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 4px 0px rgba(0, 0, 0, 0.2);
  transform: translateY(-23px);
  margin-left: 10px;
`;

export const TextConteudo = styled.p<{ primary?: boolean }>`
  text-transform: uppercase;
  color: ${colors.cinza};
  font-size: 13px;

  ${(props) =>
    props.primary &&
    css`
      color: ${colors.verde};
      font-weight: 800;
      margin-left: 5px;
    `};
`;

export const BoxMobileMenu = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: absolute;
  top: 100px;
  left: 0;
  right: 0;
  z-index: 9999;
  background: ${colors.branco};
  border: 1px solid ${colors.verde};
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.068);
  padding: 40px 20px;

  @media (max-width: 435px) {
    top: 140px;
  }
`;

export const Overlay = styled.div`
  background: rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 0;
  height: 100%;
  right: 0;
  left: 0;
  z-index: 999;
`;
